import PDFJS from 'pdfjs-dist'
import { hammerIt } from '../util'

const enableSroll = () => {
  window.onscroll = () => {}
}

const disableScroll = () => {
  const x = window.scrollX
  const y = window.scrollY
  window.onscroll = () => window.scrollTo(x, y)
}

const defaultOptions = {
  nextMessage: 'Next',
  prevMessage: 'Prev',
  footerActionsFullScreenMessage: 'Full screen',
  footerActionsZoomInMessage: 'Zoom +',
  footerActionsZoomOutMessage: 'Zoom -',
  footerActionsGoToPageMessage: 'Go to:',
  showFooterStatus: true,
  showFooterActions: true,
  showFooterActionsFullScreen: true,
  showFooterActionsZoomIn: true,
  showFooterActionsZoomOut: true,
  showFooterActionsGoToPage: true
}

const PDFViewer = {
  initThis: function () {
    this.source = null
    this.pdf = null
    this.page = 1
    this.scale = 1
    this.DOMcontainer = null
    this.DOMloading = null
    this.DOMfooter = null
    this.DOMfooterStatus = null
    this.DOMfooterActions = null
    this.DOMfooterActionsFullScreen = null
    this.DOMfooterActionsZoomIn = null
    this.DOMfooterActionsZoomOut = null
    this.DOMfooterActionsGoToPage = null
    this.DOMfooterActionsGoToPageInput = null
    this.DOMfooterActionsGoToPageButton = null
    this.DOMnavNext = null
    this.DOMnavPrev = null
    this.DOMnavNextMessage = null
    this.DOMnavPrevMessage = null
    this.DOMcanvas = null
  },

  /**
   * @function goToPage
   * @param {*} pageNumber
   */
  goToPage: function (pageNumber = this.page, scaleNumber = this.scale) {
    if (pageNumber < 1 || pageNumber > this.pdf.numPages) return

    const pageChanged = this.page !== pageNumber
    this.page = pageNumber
    this.scale = scaleNumber

    if (scaleNumber > 1.5) {
      this.scale = 1.5
    }
    if (scaleNumber < 0.5) {
      this.scale = 0.5
    }

    const _managePage = (page) => {
      const pageViewPort = page.getViewport(1 + (1 - this.scale))

      let viewport
      if ((pageViewPort.height * 2) > this.DOMcanvas.clientHeight) {
        viewport = page.getViewport(this.DOMcanvas.clientHeight / pageViewPort.height)
      } else {
        viewport = page.getViewport(this.DOMcanvas.clientWidth / pageViewPort.width)
      }

      const canvasContainer = document.createElement('div')
      const canvas = document.createElement('canvas')
      canvasContainer.appendChild(canvas)
      if (viewport.width > viewport.height) {
        const canvasContainerWidth = (viewport.width > viewport.height ? viewport.width : this.DOMcanvas.clientWidth)
        const canvasContainerHeight = (viewport.height > viewport.width ? this.DOMcanvas.clientHeight : viewport.height)
        canvasContainer.style.width = `${canvasContainerWidth}px`
        canvasContainer.style.height = `${canvasContainerHeight}px`
        canvasContainer.setAttribute('data-width', canvasContainerWidth)
        canvasContainer.setAttribute('data-height', canvasContainerHeight)
        canvas.width = (viewport.width > viewport.height ? viewport.width : this.DOMcanvas.clientWidth)
        canvas.height = (viewport.height > viewport.width ? this.DOMcanvas.clientHeight : viewport.height)
      } else {
        const canvasContainerWidth = (viewport.width > viewport.height ? this.DOMcanvas.clientWidth : viewport.width)
        const canvasContainerHeight = (viewport.height > viewport.width ? viewport.height : this.DOMcanvas.clientHeight)
        canvasContainer.style.width = `${canvasContainerWidth}px`
        canvasContainer.style.height = `${canvasContainerHeight}px`
        canvasContainer.setAttribute('data-width', canvasContainerWidth)
        canvasContainer.setAttribute('data-height', canvasContainerHeight)
        canvas.width = (viewport.width > viewport.height ? this.DOMcanvas.clientWidth : viewport.width)
        canvas.height = (viewport.height > viewport.width ? viewport.height : this.DOMcanvas.clientHeight)
      }

      const canvasContext = canvas.getContext('2d')
      const renderContext = {
        canvasContext,
        viewport,
      }

      page.render(renderContext)

      const canvasOlds = this.DOMcanvas.querySelectorAll('div')
      if (pageChanged) {
        canvasOlds.forEach((canvasOld) => { canvasOld.classList.remove('is-visible') })
        setTimeout(() => {
          this.DOMcanvas.innerHTML = ''
          this.DOMcanvas.appendChild(canvasContainer)
          hammerIt(canvasContainer)
          setTimeout(() => canvasContainer.classList.add('is-visible'), 0)
        }, 300)
      } else {
        this.DOMcanvas.innerHTML = ''
        canvasContainer.classList.add('is-visible')
        this.DOMcanvas.appendChild(canvasContainer)
        hammerIt(canvasContainer)
      }
    }

    this._goToPageLoaded = false
    this.pdf.getPage(this.page).then((page) => { this._goToPageLoaded = true; _managePage(page) })

    this.updateNavNext()
    this.updateNavPrev()
    this.updateFooter()
  },

  /**
   * @function listenNavNext
   */
  listenNavNext: function () {
    if (!this.DOMnavNext) return

    this.DOMnavNext.addEventListener('click', (e) => {
      e.preventDefault()
      
      if (this.page < this.pdf.numPages) {
        // this.scale = 1
        this.goToPage(this.page + 1)
      } else {
        // CUSTOM -> go to next PDF
        const links = document.querySelectorAll('.js-pdfviewer-links')

        for (let i = 0; i < links.length; i++) {
          const link = links[i]
          if (link.getAttribute('data-source') == this.DOMcontainer.dataset.source && i < (links.length - 1)) {
            this.DOMcontainer.innerHTML = ''
            this.DOMcontainer.setAttribute('data-source', links[i + 1].getAttribute('data-source'))
            this.init()
            break
          }
        }
      }
    })
  },
  
  /**
   * @function listenNavPrev
   */
  listenNavPrev: function () {
    if (!this.DOMnavPrev) return

    this.DOMnavPrev.addEventListener('click', (e) => {
      e.preventDefault()

      if (this.page > 1) {
        // this.scale = 1
        this.goToPage(this.page - 1)
      } else {
        // CUSTOM -> go to next PDF
        const links = document.querySelectorAll('.js-pdfviewer-links')
        for (let i = 0; i < links.length; i++) {
          const link = links[i]
          if (link.getAttribute('data-source') == this.DOMcontainer.dataset.source && i > 0) {
            this.DOMcontainer.innerHTML = ''
            this.DOMcontainer.setAttribute('data-source', links[i - 1].getAttribute('data-source'))
            this.init()
            break
          }
        }
      }
    })
  },

  /**
   * @function listenFooter
   */
  listenFooter: function () {
    if (!this.DOMfooterActions) return

    if (this.DOMfooterActionsFullScreen) {
      this.DOMfooterActionsFullScreen.addEventListener('click', (e) => {
        e.preventDefault()

        if (this.DOMcontainer.classList.contains('PDFViewerFullScreen')) {
          enableSroll()
          this.DOMfooterActionsFullScreen.classList.remove('is-active')
        } else {
          disableScroll()
          this.DOMfooterActionsFullScreen.classList.add('is-active')
        }

        this.DOMcontainer.classList.toggle('PDFViewerFullScreen')
        this.renderCanvas()
        this.goToPage(this.page)
      })
    }

    if (this.DOMfooterActionsZoomIn) {
      this.DOMfooterActionsZoomIn.addEventListener('click', (e) => {
        e.preventDefault()

        this.goToPage(this.page, this.scale + 0.1)
      })
    }

    if (this.DOMfooterActionsZoomOut) {
      this.DOMfooterActionsZoomOut.addEventListener('click', (e) => {
        e.preventDefault()

        this.goToPage(this.page, this.scale - 0.1)
      })
    }

    if (this.DOMfooterActionsGoToPageButton && this.DOMfooterActionsGoToPageInput) {
      this.DOMfooterActionsGoToPageButton.addEventListener('click', (e) => {
        e.preventDefault()
        this.goToPage(parseInt(this.DOMfooterActionsGoToPageInput.value), 1)
      })

      this.DOMfooterActionsGoToPageInput.addEventListener('change', (e) => {
        e.preventDefault()
        this.goToPage(parseInt(this.DOMfooterActionsGoToPageInput.value), 1)
      })
    }
  },

  /**
   * @function updateNavNext
   */
  updateNavNext: function () {
    if (!this.DOMnavNext) return

    if (this.page >= this.pdf.numPages) {
      // this.DOMnavNext.classList.add('PDFViewerNavDisabled')
    } else {
      // this.DOMnavNext.classList.remove('PDFViewerNavDisabled')
    }
  },

  /**
   * @function updateNavPrev
   */
  updateNavPrev: function () {
    if (!this.DOMnavPrev) return

    if (this.page <= 1) {
      // this.DOMnavPrev.classList.add('PDFViewerNavDisabled')
    } else {
      // this.DOMnavPrev.classList.remove('PDFViewerNavDisabled')
    }
  },

  /**
   * @function updateFooter
   */
  updateFooter: function () {
    if (this.DOMfooterStatus) {
      const statusWidth = (this.page * 100) / this.pdf.numPages
      this.DOMfooterStatus.style.width = `${statusWidth}%`
    }

    if (this.DOMfooterActionsGoToPageInput) {
      this.DOMfooterActionsGoToPageInput.value = this.page
    }
  },

  /**
   * @function renderCanvas
   */
  renderCanvas: function () {
    if (this.DOMcanvas) { this.DOMcanvas.parentNode.removeChild(this.DOMcanvas) }
    this.DOMcanvas = document.createElement('div')
    this.DOMcanvas.classList.add('PDFViewerCanvas')

    let width = (this.DOMcontainer.clientWidth - this.DOMnavNext.clientWidth - this.DOMnavPrev.clientWidth) * 2
    let height = (this.DOMcontainer.clientHeight - this.DOMfooter.clientHeight) * 2

    if (this.pdf.numPages < 2) {
      this.DOMcanvas.classList.add('PDFViewerCanvasWithoutNav')
      width = this.DOMcontainer.clientWidth * 2
    }

    this.DOMcanvas.style.width = `${width}px`
    this.DOMcanvas.style.height = `${height}px`

    this.DOMcontainer.appendChild(this.DOMcanvas)
  },
  
  /**
   * @function renderNavLetter
   * @param {*} navContainer 
   * @param {*} letter
   */
  renderNavLetter: function (navContainer, letter) {
    const DOMletter = document.createElement('div')
    DOMletter.classList.add('PDFViewerNavMessageLetter')
    DOMletter.innerText = letter

    navContainer.appendChild(DOMletter)
  },

  /**
   * @function renderNavPrev
   */
  renderNavPrev: function () {
    if (this.DOMnavPrev) { this.DOMnavPrev.parentNode.removeChild(this.DOMnavPrev) }
    if (this.pdf.numPages < 2) return

    this.DOMnavPrev = document.createElement('button')
    this.DOMnavPrev.classList.add('PDFViewerNav')
    this.DOMnavPrev.classList.add('PDFViewerNavPrev')
    this.DOMnavPrevMessage = document.createElement('div')
    this.DOMnavPrevMessage.classList.add('PDFViewerNavMessage')

    for (let x = 0; x < this.options.prevMessage.length; x++) {
      this.renderNavLetter(this.DOMnavPrevMessage, this.options.prevMessage[x])
    }

    this.DOMnavPrev.appendChild(this.DOMnavPrevMessage)

    this.DOMcontainer.appendChild(this.DOMnavPrev)

    this.updateNavPrev()
  },

  /**
   * @function renderNavNext
   */
  renderNavNext: function () {
    if (this.DOMnavNext) { this.DOMnavNext.parentNode.removeChild(this.DOMnavNext) }
    if (this.pdf.numPages < 2) return

    this.DOMnavNext = document.createElement('button')
    this.DOMnavNext.classList.add('PDFViewerNav')
    this.DOMnavNext.classList.add('PDFViewerNavNext')
    this.DOMnavNextMessage = document.createElement('div')
    this.DOMnavNextMessage.classList.add('PDFViewerNavMessage')

    for (let x = 0; x < this.options.nextMessage.length; x++) {
      this.renderNavLetter(this.DOMnavNextMessage, this.options.nextMessage[x])
    }

    this.DOMnavNext.appendChild(this.DOMnavNextMessage)
    this.DOMcontainer.appendChild(this.DOMnavNext)

    this.updateNavNext()
  },

  /**
   * @function renderFooter
   */
  renderFooter: function () {
    if (this.DOMfooter) { this.DOMfooter.parentNode.removeChild(this.DOMfooter) }
    this.DOMfooter = document.createElement('div')
    this.DOMfooter.classList.add('PDFViewerFooter')

    // status
    if (this.options.showFooterStatus) {
      this.DOMfooterStatus = document.createElement('div')
      this.DOMfooterStatus.classList.add('PDFViewerFooterStatus')
      this.DOMfooter.appendChild(this.DOMfooterStatus)
    }

    // actions
    if (this.options.showFooterActions) {
      this.DOMfooterActions = document.createElement('div')
      this.DOMfooterActions.classList.add('PDFViewerFooterActions')
      this.DOMfooter.appendChild(this.DOMfooterActions)
    }

    // actions - fullscreen
    if (this.options.showFooterActions && this.options.showFooterActionsFullScreen) {
      this.DOMfooterActionsFullScreen = document.createElement('button')
      this.DOMfooterActionsFullScreen.classList.add('PDFViewerFooterActionsButton')
      this.DOMfooterActionsFullScreen.innerHTML = this.options.footerActionsFullScreenMessage
      if (this.DOMcontainer.classList.contains('PDFViewerFullScreen')) {
        this.DOMfooterActionsFullScreen.classList.add('is-active')
      }
      this.DOMfooterActions.appendChild(this.DOMfooterActionsFullScreen)
    }

    // actions - zoomin
    if (this.options.showFooterActions && this.options.showFooterActionsZoomIn) {
      this.DOMfooterActionsZoomIn = document.createElement('button')
      this.DOMfooterActionsZoomIn.classList.add('PDFViewerFooterActionsButton')
      this.DOMfooterActionsZoomIn.classList.add('PDFViewerFooterActionsButtonZoomIn')
      this.DOMfooterActionsZoomIn.innerHTML = this.options.footerActionsZoomInMessage
      this.DOMfooterActions.appendChild(this.DOMfooterActionsZoomIn)
    }
    
    // actions - zoomout
    if (this.options.showFooterActions && this.options.showFooterActionsZoomOut) {
      this.DOMfooterActionsZoomOut = document.createElement('button')
      this.DOMfooterActionsZoomOut.classList.add('PDFViewerFooterActionsButton')
      this.DOMfooterActionsZoomOut.classList.add('PDFViewerFooterActionsButtonZoomOut')
      this.DOMfooterActionsZoomOut.innerHTML = this.options.footerActionsZoomOutMessage
      this.DOMfooterActions.appendChild(this.DOMfooterActionsZoomOut)
    }

    // actions - gotopage
    if (this.options.showFooterActions && this.options.showFooterActionsGoToPage) {
      this.DOMfooterActionsGoToPage = document.createElement('div')
      this.DOMfooterActionsGoToPage.classList.add('PDFViewerFooterActionsGoToPage')
      this.DOMfooterActionsGoToPageButton = document.createElement('button')
      this.DOMfooterActionsGoToPageButton.classList.add('PDFViewerFooterActionsButton')
      this.DOMfooterActionsGoToPageButton.classList.add('PDFViewerFooterActionsGoToPageButton')
      this.DOMfooterActionsGoToPageButton.innerHTML = this.options.footerActionsGoToPageMessage
      this.DOMfooterActionsGoToPageInput = document.createElement('input')
      this.DOMfooterActionsGoToPageInput.classList.add('PDFViewerFooterActionsGoToPageInput')
      this.DOMfooterActionsGoToPageInput.setAttribute('type', 'number')
      this.DOMfooterActionsGoToPageInput.setAttribute('min', 1)
      this.DOMfooterActionsGoToPageInput.setAttribute('max', this.pdf.numPages)
      this.DOMfooterActionsGoToPage.appendChild(this.DOMfooterActionsGoToPageButton)
      this.DOMfooterActionsGoToPage.appendChild(this.DOMfooterActionsGoToPageInput)
      this.DOMfooterActions.appendChild(this.DOMfooterActionsGoToPage)
    }

    this.DOMcontainer.appendChild(this.DOMfooter)

    this.updateFooter()
  },

  renderLoading: function (show) {
    if (show && this.DOMloading) return

    if (show) {
      this.DOMloading = document.createElement('div')
      this.DOMloading.classList.add('PDFViewerLoading')
      this.DOMcontainer.appendChild(this.DOMloading)
    } else {
      if (this.DOMloading) { this.DOMloading.parentNode.removeChild(this.DOMloading) }
    }
  },

  /**
   * @function loadPDF
   * @param {*} selector 
   */
  loadPDF: function (selector) {
    this.DOMcontainer = document.querySelector(selector)
    if (!this.DOMcontainer) return //throw new Error('PDFViewer selector not valid')

    const source = this.DOMcontainer.dataset.source
    if (!source) throw new Error('PDFViewer source not valid')
    this.source = atob(source)

    this.DOMcontainer.classList.add('PDFViewer')

    this.renderLoading(true)

    PDFJS.getDocument(this.source).then((pdfDoc) => {
      this.pdf = pdfDoc
      this.renderLoading(false)

      const _doAll = () => {
        this.renderFooter()
        this.renderNavNext()
        this.renderNavPrev()
        this.renderCanvas()
        this.listenFooter()
        this.listenNavNext()
        this.listenNavPrev()
        this.goToPage()
      }

      window.addEventListener('resize', () => _doAll())

      _doAll()
    })
  },

  /**
   * @function init
   * @param {*} selector 
   * @param {*} worker 
   * @param {*} options 
   */
  init: function (selector = '#PDFViewer', worker = '/pdf.worker.js', options = defaultOptions) {
    this.options = options
    PDFJS.GlobalWorkerOptions.workerSrc = worker

    this.initThis()

    this.loadPDF(selector)
  }
}

export default PDFViewer


// WEBPACK FOOTER //
// app/javascript/scripts/components/PDFViewer.js